import { actions } from '@sloyd/store-base';
import { put, takeEvery } from 'saga-ts';
import { $ac, invokeEvent, isMobile, l, setJson, setString } from 'shared-base';
import { auth0 } from '../globals';
import { customEventChannel } from './channels/channel.customEvent';
import { parseUser } from './utils/user';

export function* onAuthChange(ev: any) {
  try {
    const { data } = ev;
    const { isAuthenticated, user: userRaw, isLoading } = data;

    if (userRaw) {
      setJson('auth', userRaw);
    }

    if (!isAuthenticated && !isLoading) {
      auth0.loginWithRedirect();
      // invokeEvent('AUTH_COMPLETED', { user: {}, token: '' });
      return;
    }

    if (!userRaw) return;

    const user = parseUser(userRaw);

    yield put(actions.user.patch(user));

    // @ts-ignore
    const token = yield auth0.getAccessTokenSilently();
    setString('token', token);
    yield put(actions.appState.patch({ isAuthenticated: true }));

    invokeEvent('AUTH_COMPLETED', { user, token });
    yield put($ac('AUTH_COMPLETED'));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* root() {
  if (isMobile()) return;
  l('saga|saga.auth listening for AUTH_CHANGE custom event');
  const channel = customEventChannel('AUTH_CHANGE');
  yield takeEvery(channel, onAuthChange);
}

export const saga = {
  id: 'sloyd.auth',
  type: 'bootstrap',
  root: root,
  trigger: {},
};
